module.exports = __webpack_public_path__ + "static/media/logo-white-border.5db5b327.svg";